import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export const HomePageBreadCrumb = () => {
  const { t } = useTranslation();
  return (
    <Breadcrumb
      items={[
        {
          title: (
            <>
              <HomeOutlined />
              <span>{t('breadcrumb.admin')}</span>
            </>
          ),
        },
      ]}
    />
  );
};
